import React, { useState } from 'react';
import c from 'classnames';
import Modal from 'react-modal';
import { useTranslation } from 'react-i18next';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import BurgerIcon from '@wix/da-ds/pkg/Icons/Burger';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import NetworkBar from '../../../NetworkBar';
import s from './Burger.scss';
const Burger = ({ isBurgerMenuOpen, toggleBurgerMenu, iconClassName, showNetworkBar = true })=>{
    const { t } = useTranslation();
    const [isModalOpenAnimated, setIsModalOpenAnimated] = useState(false);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(IconButton, {
        size: "medium",
        "aria-expanded": isBurgerMenuOpen,
        "aria-label": t('siteHeader.burger.a11y'),
        "aria-controls": "burger-menu-networkbar",
        icon: BurgerIcon,
        className: iconClassName,
        onClick: ()=>{
            toggleBurgerMenu(!isBurgerMenuOpen);
        },
        biData: {
            evid: BiEventType.NETWORK_BAR_MENU_ICON
        }
    }), showNetworkBar && /*#__PURE__*/ React.createElement(Modal, {
        isOpen: isBurgerMenuOpen,
        shouldCloseOnOverlayClick: true,
        shouldCloseOnEsc: true,
        className: c(s['modal-root'], isModalOpenAnimated && s['modal-root-animated-open']),
        onAfterOpen: ()=>{
            setIsModalOpenAnimated(true);
        },
        overlayClassName: s['overlay'],
        bodyOpenClassName: null,
        onRequestClose: ()=>{
            setIsModalOpenAnimated(false);
            /* wait for animation to finish to remove the Modal */ setTimeout(()=>{
                toggleBurgerMenu(false);
            }, 300);
        }
    }, /*#__PURE__*/ React.createElement(NetworkBar, {
        id: "burger-menu-networkbar",
        isVisible: isBurgerMenuOpen,
        className: s['networkbar']
    })));
};
Burger.displayName = 'Burger';
export default Burger;
